

























import { namespace } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { CART } from '@/store/types';
import { CommonOrderDetailService } from '@/services/order/CommonOrderDetailService';

const cart = namespace(CART);

@Component({
  components: {}
})
export default class CustomerOrderIdRow extends Vue {
  public referenceNumberShown = false;
  public customerOrderId: string = null;

  private orderDetailService = CommonOrderDetailService.singleton();

  @Watch('customerOrderId')
  public onCustomerOrderId() {
    this.orderDetailService.saveCustomerId(this.customerOrderId);
  }

  public ensureValidCharacterEntered(event: KeyboardEvent) {
    const validChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789-/\\';
    if (validChars.indexOf(event.key) === -1) {
      event.preventDefault();
    }
  }
}
